import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import SupportingDocuments from 'components/SupportingDocuments';
import LocalisedMessage from 'components/Common/LocalisedMessage';
import ModalWrapper from 'components/Modals/ModalWrapper';

class SupportingDocumentsModal extends Component {
  static propTypes = {
    id: PropTypes.string,
    supportingDocs: PropTypes.arrayOf(PropTypes.shape({})),
    onCancel: PropTypes.func.isRequired,
    isFormGroup: PropTypes.bool,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired
    }).isRequired,
    locale: PropTypes.string.isRequired
  };

  static defaultProps = {
    id: null,
    supportingDocs: null,
    isFormGroup: false,
  };

  onCancel() {
    const { onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }
  }

  render() {
    const { id, supportingDocs, isFormGroup, locale, intl } = this.props;

    const title = <h1><LocalisedMessage id="modal.supportingDocuments.title" /></h1>;
    const content = <SupportingDocuments
      id={ !Number.isNaN(id) ? parseInt(id, 10) : null }
      documents={ supportingDocs }
      isFormGroup={ isFormGroup }
      locale={ locale }
    />;

    return (<ModalWrapper
      title={ title }
      closeButtonName={ intl.formatMessage({ id: 'modal.supportingDocuments.title' }) }
      className="modal-supportingdocuments"
      content={ content }
      showCancel
      showConfirm={ false }
      showFooter
      btnCancelTitle={ intl.formatMessage({ id: 'buttons.close' }) }
      btnCancelClass="alternate"
      onCancel={ () => this.onCancel() }
    />);
  }
}

function mapStateToProps(state) {
  const {
    form: {
      formData,
      isSigningForm
    }
  } = state;

  return {
    formData,
    isSigningForm
  };
}

export default connect(
  mapStateToProps
)(injectIntl(SupportingDocumentsModal));
